import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigationBarMobile from "@/src/components/Navigation/NavigationBar/Mobile/NavigationBarMobile";
import NavigationBarDesktop, { NavigationBarDesktopProps } from "@/src/components/Navigation/NavigationBar/Desktop/NavigationBarDesktop";

type NavigationBarProps = {
  minimal?: boolean;
  clickableLogo?: boolean;
};

export default function NavigationBar({ minimal, clickableLogo = true }: NavigationBarProps) {
  const isLgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const mainNavigationTabs: NavigationBarDesktopProps["mainNavigationItems"] = [
    {
      type: "category",
      label: "Rechtsbereiche",
      value: "productCategory",
      categoryMapping: [
        {
          to: "/vertragsrecht",
          label: "Vertragsrecht",
        },
        {
          to: "/mietrecht",
          label: "Mietrecht",
        },
        {
          to: "/verkehrsrecht",
          label: "Verkehrsrecht",
        },
        {
          to: "/familienrecht",
          label: "Familienrecht",
        },
        {
          to: "/arbeitsrecht",
          label: "Arbeitsrecht",
        },
        {
          to: "/allgemeines-zivilrecht",
          label: "Allgemeines Zivilrecht",
        },
      ],
    },
    {
      type: "link",
      label: "Über uns",
      to: "/ueber-uns",
      value: "/ueber-uns",
    },
    {
      type: "link",
      label: "Kontakt",
      to: "/kontakt",
      value: "/kontakt",
    },
    {
      type: "link",
      label: "Jobs",
      to: "/jobs",
      value: "/jobs",
    },
    {
      type: "link",
      label: "Partneranwalt werden",
      to: "/lp/partneranwalt-werden",
      value: "/lp/partneranwalt-werden",
    },
  ];

  const navbarProps = {
    hideActions: minimal,
    mainNavigationItems: minimal ? [] : mainNavigationTabs,
    clickableLogo,
  };

  if (isLgDown) {
    return <NavigationBarMobile {...navbarProps} />;
  }

  return <NavigationBarDesktop {...navbarProps} />;
}
